import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';
import { guruAuthorizationHeaders, studentAuthorizationHeaders } from './authService';

export const assessmentComponents = {
  soft_skills: 'Menerapkan soft skills yang dibutuhkan dalam dunia kerja (tempat PKL)',
  norma_k3lh: 'Menerapkan norma, POS dan K3LH yang ada pada dunia kerja (tempat PKL)',
  kompetensi_teknis: 'Menerapkan kompetensi teknis yang sudah dipelajari di sekolah dan/atau baru dipelajari pada dunia kerja (tempat PKL)',
  alur_bisnis: 'Memahami alur bisnis dunia kerja tempat PKL dan wawasan wirausaha',
  jurnal_laporan: 'Jurnal dan Laporan PKL',
};

export const assessmentAverage = (scores) => Object.keys(assessmentComponents)
  .reduce((sum, key) => sum + Number(scores[key] || 0), 0) / 5;

export const assessmentError = (error) => {
  const data = error?.response?.data;
  if (data?.errors) return Object.values(data.errors).flat().join(' ');
  return typeof data?.message === 'string' ? data.message : error?.message || 'Permintaan gagal.';
};

export const fetchAssessment = async (id) => (await axios.get(
  `${ApiConfig.baseUrl}/guru/siswa/${id}/penilaian`, { headers: guruAuthorizationHeaders() }
)).data.data;

export const fetchAssessmentList = async (page = 1) => (await axios.get(
  `${ApiConfig.baseUrl}/guru/penilaian`, { headers: guruAuthorizationHeaders(), params: { page } }
)).data.data;

export const saveAssessment = async (id, data) => (await axios.post(
  `${ApiConfig.baseUrl}/guru/siswa/${id}/penilaian`, data, { headers: guruAuthorizationHeaders() }
)).data.data;

export const fetchCertificate = async () => (await axios.get(
  `${ApiConfig.baseUrl}/sertifikat-pkl`, { headers: studentAuthorizationHeaders() }
)).data.data;

export const downloadCertificate = async (siswaId) => {
  const path = siswaId ? `/guru/siswa/${siswaId}/sertifikat/pdf` : '/sertifikat-pkl/pdf';
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}${path}`, {
      headers: siswaId ? guruAuthorizationHeaders() : studentAuthorizationHeaders(), responseType: 'blob',
    });
    if ((await response.data.slice(0, 5).text()) !== '%PDF-') throw new Error('File sertifikat tidak valid.');
    return response.data;
  } catch (error) {
    if (error?.response?.data instanceof Blob) {
      try { error.response.data = JSON.parse(await error.response.data.text()); } catch (_) { /* Keep original error. */ }
    }
    throw error;
  }
};
